import React from 'react';
import { FaWater } from "react-icons/fa";
import { MdOutlineVerifiedUser } from "react-icons/md";
import { MdOutlineGarage } from "react-icons/md";
import { MdOutlineNaturePeople } from "react-icons/md";
import { MdOutlineBatteryChargingFull } from "react-icons/md";
import './livingstandards.scss'

const Livingstandards = () =>
{
	return (
		<section className="living-standards-section">
			<div className="header-content">
				<h2 className="Livingstandards-section-title">What We Offer</h2>
				<p className="section-description">
					Enjoy comfortable stays with essential amenities for a relaxing experience.
				</p>
			</div>

			<div className="living-standards-amenities-grid">
				
				<div className="living-standards-amenity-card">
					<div className="icon-wrapper">
						<FaWater className="icon" />
					</div>
					<h3 className="living-standards-amenity-title">24 Hour Water</h3>
					<p className="living-standards-amenity-description">Continuous water supply available</p>
				</div>

				<div className="living-standards-amenity-card">
					<div className="icon-wrapper">
						<MdOutlineVerifiedUser className="icon" />
					</div>
					<h3 className="living-standards-amenity-title">Safe & Secure</h3>
					<p className="living-standards-amenity-description">Comfortable and trusted stays</p>
				</div>

				<div className="living-standards-amenity-card">
					<div className="icon-wrapper">
						<MdOutlineGarage className="icon" />
					</div>
					<h3 className="living-standards-amenity-title">Parking Available</h3>
					<p className="living-standards-amenity-description">Convenient vehicle space</p>
				</div>

				<div className="living-standards-amenity-card">
					<div className="icon-wrapper">
						<MdOutlineNaturePeople className="icon" />
					</div>
					<h3 className="living-standards-amenity-title">Nature-Friendly</h3>
					<p className="living-standards-amenity-description">Peaceful and relaxing environment</p>
				</div>
				
				<div className="living-standards-amenity-card">
					<div className="icon-wrapper">
						<MdOutlineBatteryChargingFull className="icon" />
					</div>
					<h3 className="living-standards-amenity-title">Inverter Backup</h3>
					<p className="living-standards-amenity-description">Power backup support available</p>
				</div>
				

			</div>
		</section>
	);
};

export default Livingstandards;